export const checkinList = {
  group: {
    sectionTitle: "Check-in associati",
    registrationForm: "Scheda di registrazione",
    registrationFormHint: "Un unico documento con l'intestatario e i suoi accompagnatori",
    registrationFormEmpty: "Non è ancora stato fatto nessun check-in per questa prenotazione.",
    registrationFormError: "Non è stato possibile generare la scheda. Riprova.",
    emptyState: "Nessun check-in associato.",
    name: "Nome",
    phone: "Telefono",
    document: "Documento",
    notAvailable: "Non disponibile",
    syncSent: "Inviato all'immigrazione",
    syncError: "Errore immigrazione",
    syncPending: "In attesa di invio",
    moreInfo: "Maggiori informazioni",
    email: "Email",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Tipo di documento",
    supportNumber: "Numero di supporto",
    documentBack: "Retro",
    identityNoMatch: "I volti non coincidono",
    identityStored: "Senza confronto facciale",
    identityError: "Impossibile confrontare",
    identityNoPhotos: "In questo paese le foto non si conservano: resta solo il risultato.",
    identityVerification: "Verifica dell'identità",
    tapToEnlarge: "Tocca per ingrandire",
    view: "Visualizza",
    download: "Scarica",
    selfie: "Selfie",
    minorData: "Dati del minore",
    relationship: "Parentela:",
    noPhotos: "Nessuna foto allegata.",
    minorDocument: "Documento del minore",
    authorization: "Autorizzazione",
    minorAuthorization: "Autorizzazione del minore",
    specification: "Specifica:",
    additionalInfo: "Informazioni aggiuntive",
    nationality: "Nazionalità",
    birthDate: "Data di nascita",
    ageYears: "({age} anni)",
    gender: "Sesso",
    female: "Femmina",
    male: "Maschio",
    countryResidence: "Paese di residenza",
    cityResidence: "Città di residenza",
    address: "Indirizzo",
    zipCode: "Codice postale",
    sesBatchId: "ID lotto SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "Paese di nascita",
    docIssuePlace: "Luogo di rilascio del documento",
    signedDocument: "Documento firmato",
    edit: "Modifica",
    remove: "Elimina",
    previewAlt: "Anteprima",
    previewFallbackTitle: "Immagine",
    docTypes: {
      passport: "Passaporto",
      passportOrdinary: "Passaporto ordinario",
      passportService: "Passaporto di servizio",
      passportDiplomatic: "Passaporto diplomatico",
      idCard: "Carta d'identità",
      nie: "NIE",
      idCardElectronic: "Carta d'identità elettronica",
      idDiplomatic: "Documento d'identità diplomatico",
      citizenshipCard: "Carta di cittadinanza",
      foreignerCard: "Carta d'identità per stranieri",
      drivingLicense: "Patente di guida",
      nauticalLicense: "Patente nautica",
      specialResidencePermit: "Permesso di soggiorno speciale",
      foreignerDocument: "Documento per stranieri",
      foreignDocument: "Documento straniero",
      diplomaticCard: "Tessera diplomatica",
      refugeeTravelDocument: "Documento di viaggio per rifugiati",
      otherDocument: "Altro documento",
    },
  },
  individual: {
    title: "Dati dell'ospite",
    phone: "Telefono",
    email: "Email",
    notAvailable: "Non disponibile",
    lodging: "Soggiorno",
    docType: "Tipo di documento",
    docNumber: "Numero del documento",
    supportNumber: "Numero di supporto",
    identityVerification: "Verifica dell'identità",
    document: "Documento",
    tapToEnlarge: "Tocca per ingrandire",
    view: "Visualizza",
    download: "Scarica",
    selfie: "Selfie",
    minorData: "Dati del minore",
    relationship: "Parentela:",
    noPhotos: "Nessuna foto allegata.",
    minorDocument: "Documento del minore",
    authorization: "Autorizzazione",
    minorAuthorization: "Autorizzazione del minore",
    specification: "Specifica:",
    additionalInfo: "Informazioni aggiuntive",
    nationality: "Nazionalità",
    birthDate: "Data di nascita",
    ageYears: "({age} anni)",
    gender: "Sesso",
    female: "Femmina",
    male: "Maschio",
    countryResidence: "Paese di residenza",
    cityResidence: "Città di residenza",
    address: "Indirizzo",
    zipCode: "Codice postale",
    sesBatchId: "ID lotto SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "Paese di nascita",
    docIssuePlace: "Luogo di rilascio del documento",
    signedDocument: "Documento firmato",
    edit: "Modifica",
    previewAlt: "Anteprima",
    previewFallbackTitle: "Immagine",
    docTypes: {
      passport: "Passaporto",
      passportOrdinary: "Passaporto ordinario",
      passportService: "Passaporto di servizio",
      passportDiplomatic: "Passaporto diplomatico",
      idCard: "Carta d'identità",
      nie: "NIE",
      idCardElectronic: "Carta d'identità elettronica",
      idDiplomatic: "Documento d'identità diplomatico",
      citizenshipCard: "Carta di cittadinanza",
      foreignerCard: "Carta d'identità per stranieri",
      drivingLicense: "Patente di guida",
      nauticalLicense: "Patente nautica",
      specialResidencePermit: "Permesso di soggiorno speciale",
      foreignerDocument: "Documento per stranieri",
      foreignDocument: "Documento straniero",
      diplomaticCard: "Tessera diplomatica",
      refugeeTravelDocument: "Documento di viaggio per rifugiati",
      otherDocument: "Altro documento",
    },
  },
};
